module.exports = __webpack_public_path__ + "img/home-comments.025898fd.png";